"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcGrey = void 0;
var calcGrey = function (hue, lightness) {
    if (hue === void 0) { hue = 255; }
    if (lightness === void 0) { lightness = 60; }
    // Linear interpolation
    var satStart = 5;
    var satEnd = 16;
    var sat = ((100 - lightness) * satEnd + lightness * satStart) / 100;
    return "hsl(".concat(hue, ", ").concat(sat, "%, ").concat(lightness, "%)");
};
exports.calcGrey = calcGrey;
//# sourceMappingURL=calc-grey.js.map